import React, { useEffect, useState } from "react";
import HeaderCustom from "../../../../components/HeaderCustom";
import { Backdrop, Box, CircularProgress, Container } from "@mui/material";
import SkeletonLoading from "../../../../components/SkeletonLoading";
import '../../../../styles/AppCss.css'
import { Padding, PaletaColor } from "../../../../styles/StylesConstantes";
import { getFiltrarCupones, getVales } from "../../../../api/ApiService";
import { DataGrid, GridActionsCellItem } from '@mui/x-data-grid';
import { Delete, Edit } from "@mui/icons-material";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import ValesHeader from "./components/ValesHeader";
import ValesFiltrosComponents from "./components/ValesFiltrosComponents";
import ValesTableComponent from "./components/ValesTableComponent";



function ValesPage() {
    const [loadingCargar, setLoadingCargar] = useState(false);
    const [loading, setLoading] = useState(false);
    const [searchFilter, setSearchFilter] = useState("");
    const [dataVales, setDataVales] = useState([]);
    const [metaPaginacion, setMetaPaginacion] = useState({
        current_page: 1,
        per_page: 10,
        total: 0,
        last_page: 1
    });
    const [perPage, setPerPage] = useState(10);



    const stateToken = useSelector(state => state.reducerGlobal.token);

    let history = useNavigate();




    useEffect(() => {
        const timeOutId = setTimeout(() => {
            if (searchFilter.length > 2) {

                handleApiFiltrarCompras(1);
            } else {
                handleApiFiltrarCompras(1);
            }
        }, 1500);
        return () => clearTimeout(timeOutId);
    }, [stateToken, searchFilter, perPage]);










    // Funcion para filtrar compras por los parametros del endpoint.
    const handleApiFiltrarCompras = (page = 1) => {
        const body = {
            page: page,
            per_page: perPage,
            titulo: searchFilter,
        };

        setLoadingCargar(true);

        getVales(stateToken?.access_token, body)
            .then((response) => {
                console.log("response==>getVales", response?.data);

                setDataVales(response?.data?.data || []);
                setLoading(true);


                setMetaPaginacion({
                    current_page: response?.data?.current_page,
                    per_page: response?.data?.per_page,
                    total: response?.data?.total,
                    last_page: response?.data?.last_page
                });
                setLoadingCargar(false);
            })
            .catch((error) => {
                console.log("error==>getVales", error);
                setDataVales([]);
                setMetaPaginacion({
                    current_page: 1,
                    per_page: perPage,
                    total: 0,
                    last_page: 1,
                });
                setLoading(true);
                setLoadingCargar(false);
            });
    };










    //=============================================funcion para editar
    const handleEditClick = (id) => {
        console.log('Edit', id);
        history(`/app/admin/cupon-detalle/${id}`);
    };


    //=============================================funcion para eliminar
    const handleDeleteClick = (id) => {
        console.log('Delete', id);
        setDataVales(dataVales.filter((row) => row.id !== id));
    }


    const columns = [
        {
            field: 'fecha_hora',
            headerName: 'Fecha/Hora',
            flex: 1,
            editable: true,
        },
        {
            field: 'cliente',
            headerName: 'Usuario',
            flex: 1,
            editable: true,
        },
        {
            field: 'ci',
            headerName: 'Cédula',
            flex: 1,
            editable: true,
        },
        {
            field: 'monto_vale',
            headerName: 'Monto del Vale',
            flex: 1,
            editable: true,
        },
        {
            field: 'monto_pagado',
            headerName: 'Monto Pagado',
            flex: 1,
            editable: true,
        },
        {
            field: 'itau',
            headerName: 'Itau',
            flex: 1,
            editable: true,
        },
        {
            field: 'nro_de_ticket_bancard',
            headerName: 'Nro. de Ticket Bancard',
            flex: 1,
            editable: true,
        },
        {
            field: 'nro_tarjeta',
            headerName: 'Nro. de Tarjeta',
            flex: 1,
            editable: true,
        },
        {
            field: 'marca_tarjeta',
            headerName: 'Marca Tarjeta',
            flex: 1,
            editable: true,
        },
        {
            field: 'tipo_tarjeta',
            headerName: 'Tipo Tarjeta',
            flex: 1,
            editable: true,
        },
        {
            field: 'ratio_utilizado',
            headerName: 'Ratio utilizado',
            flex: 1,
            editable: true,
        },
        {
            field: 'promocion',
            headerName: 'Promoción',
            flex: 1,
            editable: true,
        },
        {
            field: 'reservador',
            headerName: 'Reservador',
            flex: 1,
            editable: true,
        },
        {
            field: 'actions',
            type: 'actions',
            headerName: 'Acciones',
            flex: 1,
            cellClassName: 'actions',
            getActions: ({ id }) => {

                return [
                    <GridActionsCellItem
                        icon={<Edit />}
                        label="Edit"
                        className="textPrimary"
                        onClick={() => {
                            handleEditClick(id);
                        }}
                        color="inherit"
                    />,
                    <GridActionsCellItem
                        icon={<Delete />}
                        label="Delete"
                        onClick={() => {
                            handleDeleteClick(id);
                        }}
                        color="inherit"
                    />,
                ];
            },
        },
    ];








    //=================================================================================================funcion para ir a la pantalla de agregar
    const handleAddVale = () => {
        history('/app/admin/paseo-plus/vales/agregar');
    };

    const handleSearchChange = (value) => {
        setSearchFilter(value);
    };







    const handleEditarItem = (item) => {
        // console.log("usuario a editar==>", item);
        history(`/app/admin/paseo-plus/vales/editar/${item?.id}`);

    };

    //=============================================funcion para ver sin editar el banner
    const handleVerDetalle = (item) => {
        // console.log('Edit', item?.id);
        history(`/app/admin/paseo-plus/vales/detalle/${item?.id}?mode=view`);
    };


    const handlePerPageChange = (newPerPage) => {
        setPerPage(newPerPage);
    };






    return (
        <HeaderCustom>
            <div className="min-h-screen bg-gray-100 p-6">
                {loading ? (
                    <div>

                        <ValesHeader
                            title="Vales"
                            subtitle="Administra y supervisa los vales de la plataforma."
                            handleAdd={handleAddVale}
                        />


                        <div>
                            <ValesFiltrosComponents
                                searchValue={searchFilter}
                                onSearchChange={handleSearchChange}


                            // statusFilter={statusFilter}
                            // onStatusChange={handleStatusChange}
                            // statusOptions={statusOptions}
                            />


                            <ValesTableComponent
                                data={dataVales}
                                metaPaginacion={metaPaginacion}
                                onPageChange={handleApiFiltrarCompras}
                                perPage={perPage}
                                onPerPageChange={handlePerPageChange}
                                handleEditarItem={handleEditarItem}
                                handleVerDetalle={handleVerDetalle}
                            />
                        </div>
                    </div>
                ) : (
                    <div className="bg-white rounded-xl shadow-md p-8">
                        <div className="h-6 bg-gray-200 rounded w-1/3 mb-6 animate-pulse" />
                        <div className="space-y-4">
                            <div className="h-10 bg-gray-200 rounded animate-pulse" />
                            <div className="h-10 bg-gray-200 rounded animate-pulse" />
                            <div className="h-24 bg-gray-200 rounded animate-pulse" />
                        </div>
                    </div>
                )}


                <Backdrop open={loadingCargar} sx={(theme) => ({ color: '#fff', zIndex: theme.zIndex.drawer + 1 })}>
                    <CircularProgress color="inherit" />
                </Backdrop>
            </div>
        </HeaderCustom>
    );
}

export default ValesPage;